import type { CSSProperties } from "react";
import { Icon } from "./Icon.js";

interface ProgressRingProps {
  /** 0..100 reading/quiz completion */
  pct: number;
  size?: number;
  /** quiz passed → fill lime + show a check in the hole */
  done?: boolean;
  label?: string;
  style?: CSSProperties;
}

/**
 * A conic-gradient progress ring masked to a donut (no SVG, no new colour).
 * faint track = unread, lime arc = in-progress, full lime + check = quiz-passed.
 * The arc is drawn by `.ring::before` (masked); the check child sits in the hole un-masked.
 * See `.ring` in tebiki.css.
 */
export function ProgressRing({ pct, size = 26, done = false, label, style }: ProgressRingProps) {
  const p = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <span
      className={`ring${done ? " ring--done" : ""}`}
      role="img"
      aria-label={label ?? (done ? "修了" : `進捗 ${p}%`)}
      style={{ width: size, height: size, "--pct": done ? 100 : p, ...style } as CSSProperties}
    >
      {done ? <Icon name="check" size={Math.round(size * 0.52)} style={{ color: "var(--hi-deep)" }} /> : null}
    </span>
  );
}
